export default __webpack_public_path__ + "static/media/tour4.4d24931d.png";